"use strict";

var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = reducer;

var _set = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/set"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _parseInt = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/parse-int"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _useListBox = _interopRequireDefault(require("../useListBox"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function reducer(state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _useListBox["default"].types.closePopover:
      return _objectSpread(_objectSpread({}, state), {}, {
        filteredOptions: [],
        isOpen: false
      });

    case _useListBox["default"].types.openPopover:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeOption: state.selectedOptions.length ? state.selectedOptions[state.selectedOptions.length - 1] : null,
        isOpen: true
      });

    case _useListBox["default"].types.togglePopover:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpen: !state.isOpen
      });

    case _useListBox["default"].types.setActiveOption:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeOption: payload.activeOptionIndex
        });
      }

    case _useListBox["default"].types.selectSingleOption:
      {
        var isOpen = payload.isOpen;

        if (state.hasFooter) {
          isOpen = true;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          onChangeFn: payload.onChangeFn,
          activeOption: payload.activeOptionIndex,
          isOpen: isOpen,
          selectedOptions: [payload.activeOptionIndex]
        });
      }

    case _useListBox["default"].types.selectMultipleOption:
      {
        var activeOptionIndex = payload.activeOptionIndex,
            isSelected = payload.isSelected;
        var selectedOptions = [];

        if (isSelected) {
          // remove duplicates
          selectedOptions = (0, _toConsumableArray2["default"])(new _set["default"]([].concat((0, _toConsumableArray2["default"])(state.selectedOptions), [activeOptionIndex])));
        } else if (state.selectedOptions.includes(activeOptionIndex)) {
          selectedOptions = state.selectedOptions.slice(0);
          var index = selectedOptions.indexOf(activeOptionIndex);
          selectedOptions.splice(index, 1);
        } else {
          return _objectSpread({}, state);
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          activeOption: activeOptionIndex,
          onChangeFn: payload.onChangeFn,
          selectedOptions: selectedOptions
        });
      }

    case _useListBox["default"].types.toggleMultipleOption:
      {
        var selectedOptionsArray = state.selectedOptions.slice();
        var _activeOptionIndex = payload.activeOptionIndex,
            onChangeFn = payload.onChangeFn;

        if (selectedOptionsArray.includes(_activeOptionIndex)) {
          var _index = selectedOptionsArray.indexOf(_activeOptionIndex);

          selectedOptionsArray.splice(_index, 1);
        } else {
          selectedOptionsArray.push(_activeOptionIndex);
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          activeOption: _activeOptionIndex,
          onChangeFn: onChangeFn,
          selectedOptions: selectedOptionsArray
        });
      }

    case _useListBox["default"].types.hasFilter:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          hasFilter: payload
        });
      }

    case _useListBox["default"].types.applyFilter:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          filteredOptions: payload.filteredOptions,
          noResultsFound: payload.noResultsFound
        });
      }

    case _useListBox["default"].types.setTriggerWidth:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          triggerWidth: payload
        });
      }

    case _useListBox["default"].types.setHasPopupOpened:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          hasPopupOpened: payload
        });
      }

    case _useListBox["default"].types.updateOptions:
      {
        var options = payload.options,
            optionsIndex = payload.optionsIndex;

        var _selectedOptions = (0, _keys["default"])(options).filter(function (key) {
          return options[key].isSelected;
        }).map(function (key) {
          return (0, _parseInt["default"])(key, 10);
        });

        return _objectSpread(_objectSpread({}, state), {}, {
          options: options,
          optionsIndex: optionsIndex,
          selectedOptions: _selectedOptions,
          lastKnownSelectedOptions: (0, _toConsumableArray2["default"])(_selectedOptions)
        });
      }

    case _useListBox["default"].types.unselectOptions:
      {
        if (!(0, _isArray["default"])(payload)) {
          throw new Error("unselectOptions action expect an array as a payload");
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          selectedOptions: state.selectedOptions.filter(function (index) {
            return !payload.includes(index);
          })
        });
      }

    case _useListBox["default"].types.hideOptions:
      {
        if (!(0, _isArray["default"])(payload)) {
          throw new Error("hideOptions action expect an array as a payload");
        }

        var optionsClone = _objectSpread({}, state.options);

        payload.forEach(function (index) {
          optionsClone[index].isHidden = true;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          options: optionsClone
        });
      }

    case _useListBox["default"].types.unhideOptions:
      {
        if (!(0, _isArray["default"])(payload)) {
          throw Error("unhideOptions action expect an array as a payload");
        }

        var _optionsClone = _objectSpread({}, state.options);

        payload.forEach(function (index) {
          _optionsClone[index].isHidden = false;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          options: _optionsClone
        });
      }

    case _useListBox["default"].types.clear:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeOption: null,
          isOpen: payload && payload.isOpen || false,
          onChangeFn: payload && payload.onChangeFn ? payload.onChangeFn : null,
          selectedOptions: []
        });
      }

    case _useListBox["default"].types.reset:
      {
        return _objectSpread(_objectSpread({}, state.originalState), {}, {
          isOpen: false,
          onChangeFn: payload && payload.onChangeFn ? payload.onChangeFn : null,
          originalState: state.originalState
        });
      }

    case _useListBox["default"].types.accept:
      {
        var _selectedOptions2 = state.selectedOptions.slice(0);

        return _objectSpread(_objectSpread({}, state), {}, {
          isOpen: false,
          selectedOptions: _selectedOptions2,
          lastKnownSelectedOptions: _selectedOptions2,
          onChangeFn: payload.onChangeFn
        });
      }

    case _useListBox["default"].types.cancel:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isOpen: false,
          onChangeFn: payload && payload.onChangeFn ? payload.onChangeFn : null,
          selectedOptions: state.lastKnownSelectedOptions.slice(0)
        });
      }

    case _useListBox["default"].types.setHeight:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          height: payload
        });
      }

    case _useListBox["default"].types.setHasFooter:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          hasFooter: payload
        });
      }

    case _useListBox["default"].types.cleanOnChangeFn:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          onChangeFn: null
        });
      }

    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map